<script>
import Main from './main.vue';

export default Main.extend({
  methods: {
    getData() {
      return [
        {
          name: 'Industry sector(s)',
          data: [{
            x: 0,
            y: 1,
            data: this.chartData.IndustrySectorCount,
          }],
        },
      ];
    },
  },
});
</script>
